import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import { Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';

import {
  FileService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../../core/core.module';
import { State } from '../../../../vista-usuario/vista-usuario.state';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FormBuilder } from '@angular/forms';

import { entityTecnicoResponsableChangeRequest } from '../../entity-tecnico-responsable.actions';

import { TecnicoResponsable } from '../../entity-tecnico-responsable.model';

//TODO ARREGLAR ESTO
@Component({
  selector: 'rpe-entity-tecnico-responsable-acreditacion-dialog-form-container',
  templateUrl:
    './entity-tecnico-responsable-acreditacion-dialog-form-container.component.html',
  styleUrls: [
    './entity-tecnico-responsable-acreditacion-dialog-form-container.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityTecnicoResponsableAcreditacionDialogFormContainerComponent
  implements OnInit
{
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  title: string;
  submitText: string;

  formValid = false;
  formValue: TecnicoResponsable;
  formInput: TecnicoResponsable;

  constructor(
    private fb: FormBuilder,
    private store: Store<State>,
    private fileService: FileService,
    public dialogRef: MatDialogRef<EntityTecnicoResponsableAcreditacionDialogFormContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TecnicoResponsable
  ) {
    this.formInput = data;
  }

  ngOnInit() {
    this.submitText = 'Enviara';
  }

  formStatusChanges(status: string) {
    this.formValid = status === 'VALID';
  }

  formValueChanges(tecnicoResponsable: TecnicoResponsable) {
    this.formValue = {
      ...tecnicoResponsable
    };
  }

  save() {
    let tecnico = this.formValue.tecnico;
    tecnico.acreditado = 2;
    const item = {
      ...this.formValue,
      tecnico: tecnico
    };
    if (this.formValue.carta_recomendacion) {
      forkJoin([
        this.fileService.uploadFile(this.formValue.cv),
        this.fileService.uploadFile(this.formValue.carta_recomendacion)
      ]).subscribe((results) => {
        item.cv = results[0];
        item.carta_recomendacion = results[1];
        this.store.dispatch(
          entityTecnicoResponsableChangeRequest({
            item
          })
        );
      });
    } else {
      this.fileService.uploadFile(this.formValue.cv).subscribe((result) => {
        item.cv = result;
        this.store.dispatch(
          entityTecnicoResponsableChangeRequest({
            item
          })
        );
      });
    }
  }

  onSubmit() {
    if (this.formValid) {
      this.save();
      this.dialogRef.close(false);
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
